import { DEFAULT_CHANNEL_ID, DEFAULT_TTL_SECONDS } from '../config/pushChannels';
import type { PushOptionsValue } from '../types/push';

export const DEFAULT_PUSH_OPTIONS: PushOptionsValue = {
  name: '',
  screen: '',
  sound: true,
  androidChannelId: DEFAULT_CHANNEL_ID,
  ttlSeconds: DEFAULT_TTL_SECONDS,
  customData: [],
};

// Espelha a validação da API (client/api/_lib/push/validate.js) só para avisar
// antes de enviar; quem decide continua sendo a API.
const RESERVED_KEYS = ['campaignId', 'rid', 'screen', 'from', 'notification', 'message_type', 'collapse_key'];
const RESERVED_PREFIXES = ['google', 'gcm'];
const KEY_PATTERN = /^[A-Za-z0-9_.-]{1,40}$/;

/** Primeiro problema nos dados personalizados, ou null. Linhas totalmente vazias são ignoradas. */
export const customDataError = (rows: PushOptionsValue['customData']): string | null => {
  const seen: string[] = [];
  for (const row of rows) {
    const key = row.key.trim();
    if (!key && !row.value.trim()) continue;
    if (!key) return 'Preencha a chave de todos os dados personalizados';
    if (!KEY_PATTERN.test(key)) return `Chave inválida: "${key}". Use letras, números, "_", "-" ou "." (até 40 caracteres)`;
    if (RESERVED_KEYS.includes(key) || RESERVED_PREFIXES.some(prefix => key.toLowerCase().startsWith(prefix))) {
      return key === 'screen'
        ? 'A chave "screen" é reservada. Use o campo "Tela de destino"'
        : `A chave "${key}" é reservada`;
    }
    if (seen.includes(key)) return `A chave "${key}" está repetida`;
    seen.push(key);
  }
  return null;
};

export const customDataToObject = (rows: PushOptionsValue['customData']): Record<string, string> =>
  rows.reduce<Record<string, string>>((data, row) => {
    const key = row.key.trim();
    return key ? { ...data, [key]: row.value } : data;
  }, {});
